module.exports = __webpack_public_path__ + "static/media/bath.7ee686ea.svg";